/**
 * アクセシビリティ用のフォーカス枠線を制御
 * focus-visible状態の要素に枠線を追従させる
 * 
 * @example
 * // 初期化
 * const focusManager = new A11yFocusOutline();
 * 
 * @example
 * // HTML側でスタイルを指定
 * <button data-a11y-selection-class="button-style">ボタン</button>
 */
class A11yFocusOutline {
    constructor() {
        this.outline = document.querySelector('.a11y-selection');
        this.targetElement = null;
        this.animationId = null;
        // 直前の操作がタップ・クリックだったか
        this.isPointerInteraction = false;

        if (!this.outline) {
            console.error('.a11y-selection要素が見つからないよ！');
            return;
        }

        this.init();
    }

    /**
     * イベントリスナーを設定
     */
    init() {
        // タップ・クリックでのフォーカスは対象外にする。
        // 入力欄はタップでも:focus-visibleになるため、iOSでキーボードが出ると
        // position:fixedの枠線が実際の入力欄からずれて見えてしまう。
        document.addEventListener('pointerdown', () => {
            this.isPointerInteraction = true;
        }, true);

        // focus-visibleをサポートしてるか確認
        document.addEventListener('focusin', (e) => {
            if (this.isPointerInteraction) {
                return;
            }

            // focus-visibleの疑似クラスをチェック
            if (e.target.matches(':focus-visible')) {
                this.startTracking(e.target);
            }
        });

        document.addEventListener('focusout', () => {
            this.stopTracking();
        });

        document.addEventListener('keydown', (e) => {
            // キーボード操作に戻ったら枠線を出す対象に戻す
            this.isPointerInteraction = false;

            // Escキーでも非表示
            if (e.key === 'Escape') {
                this.stopTracking();
            }
        }, true);
    }

    /**
     * 要素の追跡を開始
     * @param {HTMLElement} element - 追跡対象の要素
     */
    startTracking(element) {
        this.targetElement = element;

        // data-a11y-selection-classがあればdata属性を追加
        const customValue = element.dataset.a11ySelectionClass;
        if (customValue) {
            this.outline.dataset.a11ySelectionClass = customValue;
        }

        this.outline.style.opacity = '1';
        this.updatePosition();
    }

    /**
     * 要素の追跡を停止
     */
    stopTracking() {
        this.targetElement = null;
        this.outline.style.opacity = '0';

        // data属性を削除
        delete this.outline.dataset.a11ySelectionClass;

        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
            this.animationId = null;
        }
    }

    /**
     * 枠線の位置とサイズを更新
     */
    updatePosition() {
        if (!this.targetElement) return;

        const rect = this.targetElement.getBoundingClientRect();

        this.outline.style.width = `${rect.width}px`;
        this.outline.style.height = `${rect.height}px`;
        this.outline.style.transform = `translate(${rect.left}px, ${rect.top}px)`;

        // 次のフレームでも更新
        this.animationId = requestAnimationFrame(() => this.updatePosition());
    }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
    new A11yFocusOutline();
});